const SELECTOR = '#emergent-badge, a[href*="emergent.sh"], a[href*="app.emergent.sh"]';

export const stripEmergentBadge = () => {
  document.querySelectorAll(SELECTOR).forEach((el) => el.remove());
};

if (typeof window !== 'undefined') {
  stripEmergentBadge();
  const observer = new MutationObserver(stripEmergentBadge);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', stripEmergentBadge);
  setInterval(stripEmergentBadge, 500);
}
